<template>
    <div>
        <div v-if='selected_local_store' class='currently-selected-local-store'>Current local store: {{selected_local_store.name}}</div>
        <div class='store-lookup-container'>
            <Field id='postcode_store_lookup' :errors='errors' class='lookup-postcode' >
                <input type="text" autocomplete="off" v-model='postcode' placeholder="Postcode" @keydown="onEnterPress"/>
            </Field>
            <Button class='lookup-button' text='Find local store' theme='dark' @click='getNearestStores'/>
        </div>
    </div>
</template>
<script>
import Field from '@/ecom/components/fields/Field.vue';
import Button from '@/ecom/components/buttons/Button.vue';
export default {
    components: {Field, Button},
    emits: ['postcodeListener'],
    props:['reset_postcode', 'errors', 'selected_local_store'],
    data(){
        return{
            postcode: '',
        }
    },
    methods:{
        onEnterPress(e){
            if(e.keyCode == 13){
                this.$emit('postcodeListener', this.postcode);
            }
        },
        getNearestStores() {
            this.$emit('postcodeListener', this.postcode);
        }
    },
    watch:{
        'reset_postcode': function(new_val){
            this.postcode = new_val;
        }
    }
}
</script>
<style lang="scss" scoped>
.currently-selected-local-store{
    // font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 15px;
}
.store-lookup-container{
    display: flex;
    gap: 30px;
}
.lookup-postcode{
    width: 300px;
}
.lookup-button{
    width: 200px;
    height: 50px;
}
</style>
